import { ActionReducer, MetaReducer} from "@ngrx/store";
import {ActionTypes} from "./clear.action";
import {AppState} from "../../../../app.reducer";
import * as placeOrder from "../place-order/place-order-reducer";
import * as menu from "../menu/menu.reducer";
import * as menuOrder from "../menu-order/menu-order.reducer";

export function clearStateMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state, action) {
    if (action.type === ActionTypes.LOGOUT) {
      state = {
        menuOrder: menuOrder.initialState,
        ...state,
        placeOrder: placeOrder.initialState,
        menu: menu.initialState
      }
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearStateMetaReducer];



